
<div>
  <h1 class="header">Stand with the only news network that stands with 
    you.
  </h1>

  Access <strong>member exclusive benefits</strong> and support the only news 
  network that covers the issues you really care about. like:


  <div class="issues">
    <div class="issue">
      <img src="/assets/signup-icons/green_deal.svg" />
      <div>
        The Green New Deal 
      </div>
    </div>
    <div class="issue">
      <img src="/assets/signup-icons/medicare.svg" />
      <div>
        Medicare For All
      </div>
    </div>
    <div class="issue">
      <img src="/assets/signup-icons/college_for_all.svg" />
      <div>
        College For All
      </div>
    </div>
    <div class="issue">
      <img src="/assets/signup-icons/living_wage.svg" />
      <div>
        A Living Minimum Wage
      </div>
    </div>
    <div class="issue">
      <img src="/assets/signup-icons/banning_private.svg" />
      <div>
        Banning Private Financing For Elections
      </div>
    </div>
  </div>

  <div class="btn-container">
    <a href="{{joinUrl}}">Learn More About Membership</a>
  </div>

</div>